import { createContext, useContext } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

/**
 * Horizontal safe area of the enclosing tab stack, set by TabStackLayout. Unlike the window's, it includes the iPadOS
 * sidebar, which only insets the tab content.
 */
export const TabHorizontalSafeAreaContext = createContext<{ left: number; right: number } | null>(null)

/**
 * contentInsetAdjustmentBehavior="automatic" only adjusts the scrolling axis, so lists run under the side bar on
 * iPhone Duo. Pad the content rather than the list so the scroll indicator stays at the screen edge, as UITableView
 * does. Drop this once react/react-native#59194 ships, which pads the content natively.
 */
export default function useHorizontalSafeAreaPadding() {
  const windowInsets = useSafeAreaInsets()
  const { left, right } = useContext(TabHorizontalSafeAreaContext) ?? windowInsets

  return { paddingLeft: left, paddingRight: right }
}
